"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
var react_1 = __importDefault(require("react"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var styles_1 = require("@material-ui/core/styles");
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        paper: {
            marginTop: 10,
        },
    });
});
exports.DropDown = function (_a) {
    var other = __rest(_a, []);
    var menuClasses = useStyles();
    return (react_1.default.createElement(Select_1.default, __assign({ variant: "outlined" }, other, { IconComponent: function (props) { return (react_1.default.createElement(ExpandMore_1.default, __assign({ style: { marginRight: 14.5 } }, props))); }, MenuProps: {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left",
            },
            getContentAnchorEl: null,
            classes: __assign({}, menuClasses),
        } })));
};
